<template>
	<div class="page-payment-rule page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="12">
					<h3 style="float: none;">支付规则管理</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置:</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>支付管理</el-breadcrumb-item>
							<el-breadcrumb-item>支付规则</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
				<el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
					<el-button type="primary" class="btn-bg-p" @click="handleItem('add')">添加 <i class="el-icon-plus"></i></el-button>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="table-block content-body">
					<div ref="contentBody">
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
							<el-table-column prop="name" align="center" label="规则名称" min-width="160"></el-table-column>
							<el-table-column prop="code" align="center" label="规则编码" min-width="120"></el-table-column>
							<!-- <el-table-column prop="serviceType" align="center" label="服务费类型" min-width="120">
							<template slot-scope="scope">
								<span v-if="scope.row.serviceType === 'percent'">百分比</span>
								<span v-else-if="scope.row.serviceType === 'fixed'">固定金额</span>
								<span v-else>-</span>
							</template>
						</el-table-column>
							<el-table-column prop="serviceFeePercent" align="center" label="服务费百分比" min-width="120">
								<template slot-scope="scope">
									{{ scope.row.serviceFeePercent ? scope.row.serviceFeePercent + '%' : '-' }}
								</template>
							</el-table-column>
							<el-table-column prop="serviceFeeEachOrder" align="center" label="服务费固定金额" min-width="120">
								<template slot-scope="scope">
									{{ scope.row.serviceFeeEachOrder ? '¥' + scope.row.serviceFeeEachOrder : '-' }}
								</template>
							</el-table-column> -->
							<el-table-column prop="createdate" align="center" label="创建时间" min-width="160"></el-table-column>
							<el-table-column prop="operating" align="center" label="操作" min-width="200" fixed="right">
								<template slot-scope="scope">
									<el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleItem('edit',scope.row)">编辑</el-button>
									<el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteItem(scope.row.icode)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="table_data.page_info.page" :page-sizes="[10,30,50,80,100]" :page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next" :total="table_data.page_info.total"></el-pagination>
				</div>
			</div>
		</div>
		<el-dialog class="dialog-export" :title="dlg_item.title" :visible.sync="dlg_item.visible" width="1100px" @close="closeDialog" :close-on-click-modal="false">
			<el-form ref="formItem" :model="dlg_item.form" label-width="140px" :rules="dlg_item.rules" @submit.native.prevent>
				<el-form-item prop="name" label="规则名称:">
					<el-input size="small" v-model="dlg_item.form.name" placeholder='请输入规则名称' clearable></el-input>
				</el-form-item>
				<el-form-item prop="code" label="规则编码:">
					<el-input size="small" v-model="dlg_item.form.code" placeholder='请输入规则编码' clearable></el-input>
				</el-form-item>
				<!-- <el-form-item prop="serviceType" label="服务费类型:">
					<el-select size="small" v-model="dlg_item.form.serviceType" placeholder="请选择服务费类型" style="width:100%;">
						<el-option label="百分比" value="percent"></el-option>
						<el-option label="固定金额" value="fixed"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="serviceFeePercent" label="服务费百分比:" v-if="dlg_item.form.serviceType === 'percent'">
					<el-input size="small" type='number' v-model="dlg_item.form.serviceFeePercent" placeholder='请输入服务费百分比' clearable>
						<template slot="append">%</template>
					</el-input>
				</el-form-item>
				<el-form-item prop="serviceFeeEachOrder" label="服务费固定金额:" v-if="dlg_item.form.serviceType === 'fixed'">
					<el-input size="small" type='number' v-model="dlg_item.form.serviceFeeEachOrder" placeholder='请输入服务费固定金额' clearable>
						<template slot="prepend">¥</template>
					</el-input>
				</el-form-item> -->
				<el-divider>规则细项</el-divider>
				<el-form-item label="" label-width="0" style="margin-bottom: 10px;">
					<el-button size="small" type="primary" @click="addRuleItem" style="margin-left: 0;">添加细项</el-button>
				</el-form-item>
				<el-table :data="dlg_item.form.items" border style="width: 100%">
					<el-table-column label="名称" width="100">
						<template slot-scope="scope">
							<el-input size="small" v-model="scope.row.name" placeholder="名称"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="人员类型">
						<template slot-scope="scope">
							<el-select size="small" v-model="scope.row.type" placeholder="人员类型" style="width:100%;">
								<el-option v-for="item in dlg_item.type_list" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column label="子商户号" width="140">
						<template slot-scope="scope">
							<el-input size="small" v-model="scope.row.subMchId" placeholder="子商户号"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="开始时间" width="130">
						<template slot-scope="scope">
							<el-time-picker size="small" v-model="scope.row.startTime" format="HH:mm" value-format="HH:mm" placeholder="开始时间" style="width:100%;"></el-time-picker>
						</template>
					</el-table-column>
					<el-table-column label="结束时间" width="130">
						<template slot-scope="scope">
							<el-time-picker size="small" v-model="scope.row.endTime" format="HH:mm" value-format="HH:mm" placeholder="结束时间" style="width:100%;"></el-time-picker>
						</template>
					</el-table-column>
          <el-table-column label="金额(元)" width="80">
            <template slot-scope="scope">
              <el-input size="small" type="number" v-model="scope.row.money" placeholder="金额"></el-input>
            </template>
          </el-table-column>
					<el-table-column label="操作" width="80">
						<template slot-scope="scope">
							<el-button size="mini" type="danger" @click="removeRuleItem(scope.$index)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dlg_item.visible = false">取 消</el-button>
				<el-button type="primary" @click="submitItem()" :loading="dlg_item.btn_loading">确认</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: 'paymentRuleList',
	data() {
		return {
			body_loading: false,
			table_data: {
				loading: false,
				list: [],
				page_info: {
					page: 1,
					pageSize: 10,
					total: 0
				}
			},
			dlg_item: {
				visible: false,
				btn_loading: false,
				title: '',
				api: '',
				form: {
					icode: '',
					name: '',
					code: '',
					// serviceType: '',
					// serviceFeePercent: 0,
					// serviceFeeEachOrder: 0,
					items: []
				},
				type_list: [],
				reset_form: {},
				rules: {
					name: {required: true, message: '请输入规则名称', trigger: ['change','blur']},
					code: {required: true, message: '请输入规则编码', trigger: ['change','blur']},
					// serviceType: {required: true, message: '请选择服务费类型', trigger: ['change','blur']}
				}
			}
		}
	},
	created() {
		document.title = '支付规则管理';
		this.dlg_item.reset_form = JSON.parse(JSON.stringify(this.dlg_item.form));
		this.getList();
		this.getTypeList();
	},
	methods: {
		getList() {
			var _this = this;
			var params = {
				pageNo: _this.table_data.page_info.page,
				pageSize: _this.table_data.page_info.pageSize
			};
			_this.table_data.loading = true;
			this.$client.get('/api/biz/pay/rule/getList', params, function(res, message, total) {
				if (res && res.records) {
					_this.table_data.list = res.records;
					_this.table_data.page_info.total = res.total;
				}
				_this.table_data.loading = false;
			}, function(res) {
				_this.table_data.loading = false;
			});
		},
		getTypeList() {
			var _this = this;
			this.$client.get('/api/biz/business/traveler/getListBusinessTravelerType', {}, function(res) {
				if (res && Array.isArray(res)) {
					_this.dlg_item.type_list = res.map(item => ({
						label: item.name || item.label || item,
						value: item.value || item.code || item
					}));
				}
        _this.dlg_item.type_list.push({
          label: '在编/外包',
          value: '在编/外包',
        })
        _this.dlg_item.type_list.push({
          label: '物业公务班组',
          value: '物业公务班组',
        })
			});
		},
		handleSizeChange(val) {
			this.table_data.page_info.pageSize = val;
			this.getList();
		},
		handleCurrentChange(val) {
			this.table_data.page_info.page = val;
			this.getList();
		},
		handleItem(type, data) {
			var _this = this;
			this.dlg_item.visible = true;
			if (type == 'add') {
				this.dlg_item.title = '添加支付规则';
				this.dlg_item.api = '/api/biz/pay/rule/add';
			} else {
				this.dlg_item.title = '编辑支付规则';
				this.dlg_item.api = '/api/biz/pay/rule/update';
				// 获取详情
				this.$client.get('/api/biz/pay/rule/getModel', {id: data.icode}, function(res) {
					_this.dlg_item.form.icode = res.icode;
					_this.dlg_item.form.name = res.name;
					_this.dlg_item.form.code = res.code;
					// _this.dlg_item.form.serviceType = res.serviceType;
					// _this.dlg_item.form.serviceFeePercent = res.serviceFeePercent;
					// _this.dlg_item.form.serviceFeeEachOrder = res.serviceFeeEachOrder;
					_this.dlg_item.form.items = res.items || [];
				});
			}
		},
		addRuleItem() {
			this.dlg_item.form.items.push({
				icode: '',
				ruleId: '',
				money: 0,
				name: '',
				type: '',
				subMchId: '',
				startTime: '',
				endTime: '',
				sortNum: 0
			});
		},
		removeRuleItem(index) {
			this.dlg_item.form.items.splice(index, 1);
		},
		deleteItem(id) {
			var _this = this;
			this.$confirm('确定要删除？', "", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				iconClass: "icon-delete el-icon-delete",
				customClass: "my-confirm-box",
				center: true
			}).then(() => {
				_this.$client.post('/api/biz/pay/rule/delete', {id: id}, function(res, message) {
					_this.$message(message);
					_this.getList();
				});
			}).catch(() => {});
		},
		submitItem() {
			var _this = this;
			_this.$refs['formItem'].validate((valid) => {
				if (valid) {
					var submitData = JSON.parse(JSON.stringify(_this.dlg_item.form));
					// 自动设置排序号
					submitData.items.forEach((item, index) => {
						item.sortNum = index + 1;
					});
					_this.dlg_item.btn_loading = true;
					_this.$client.post(_this.dlg_item.api, submitData, function(res, message) {
						_this.$message(message);
						_this.getList();
						_this.dlg_item.btn_loading = false;
						_this.dlg_item.visible = false;
					}, function(message) {
						_this.dlg_item.btn_loading = false;
					});
				}
			});
		},
		closeDialog() {
			this.dlg_item.form = JSON.parse(JSON.stringify(this.dlg_item.reset_form));
			this.$nextTick(() => {
				this.$refs.formItem.clearValidate();
			});
		}
	}
}
</script>
<style scoped>
</style>
